import { render, staticRenderFns } from "./ReviewCardResolved.vue?vue&type=template&id=aefefd48&scoped=true&"
import script from "./ReviewCardResolved.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewCardResolved.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewCardResolved.vue?vue&type=style&index=0&id=aefefd48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefefd48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aefefd48')) {
      api.createRecord('aefefd48', component.options)
    } else {
      api.reload('aefefd48', component.options)
    }
    module.hot.accept("./ReviewCardResolved.vue?vue&type=template&id=aefefd48&scoped=true&", function () {
      api.rerender('aefefd48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/ReviewCardResolved.vue"
export default component.exports